import { postData } from "../base.ehq.model";

export const verifyRecaptcha = async (
  token,
  baseUrl,
  recaptchaToken,
  action,
  version = "v3"
) => {
  const queryPath = `${baseUrl}/recaptcha_verifications`;
  const body = {
    recaptcha_token: recaptchaToken,
    action,
    version
  };

  try {
    const response = await postData(token, queryPath, {}, body);
    return response.data;
  } catch (err) {
    throw new Error(err);
  }
};
